export default "__VITE_ASSET__BbaJS2x2__"